/* Product cards render one .card__color-dot button per color option value
   (snippets/card-product.liquid), each carrying its own poster/hover image
   data (a fixed block of 4 media images per color, position-based: 1st
   color -> images 1-4, 2nd -> 5-8, 3rd -> 9-12, ...). Clicking a dot swaps
   the card's own poster <img> (data-color-swatch-image="poster") and hover
   <img> (data-color-swatch-image="hover") to that color's pair — the
   existing .media--hover-effect CSS (base.css) already fades between
   whichever two <img> elements are there on :hover, so no extra JS is
   needed for the hover behavior itself, only for swapping which images
   those two <img> tags point to.

   It also rewrites the card's own image/title links to
   "{{ card_product.url }}?variant=..." (each dot's data-variant-url,
   computed server-side in card-product.liquid) — Shopify natively pre-
   selects whichever variant a ?variant= param points to, so a shopper who
   picks a color here and then clicks through lands on the product page
   with that same color already selected, instead of always the card's
   original default variant regardless of what was picked on the card.

   Single delegated document listener, guarded against double-registration
   — this file is loaded from snippets/card-product.liquid, which renders
   once per product card, so the <script> tag itself can appear many times
   on one page. */
if (!window.__cardColorSwatchWired) {
  window.__cardColorSwatchWired = true;

  document.addEventListener('click', (event) => {
    const dot = event.target.closest('.card__color-dot');
    if (!dot) return;

    const card = dot.closest('.card');
    if (!card) return;

    const poster = card.querySelector('[data-color-swatch-image="poster"]');
    if (poster && dot.dataset.posterSrc) {
      poster.src = dot.dataset.posterSrc;
      poster.srcset = dot.dataset.posterSrcset || '';
      poster.alt = dot.dataset.posterAlt || '';
      if (dot.dataset.posterWidth) poster.width = dot.dataset.posterWidth;
      if (dot.dataset.posterHeight) poster.height = dot.dataset.posterHeight;
    }

    const hover = card.querySelector('[data-color-swatch-image="hover"]');
    if (hover && dot.dataset.hoverSrc) {
      hover.src = dot.dataset.hoverSrc;
      hover.srcset = dot.dataset.hoverSrcset || '';
      hover.alt = dot.dataset.hoverAlt || '';
      if (dot.dataset.hoverWidth) hover.width = dot.dataset.hoverWidth;
      if (dot.dataset.hoverHeight) hover.height = dot.dataset.hoverHeight;
    }

    dot
      .closest('.card__color-dots')
      ?.querySelectorAll('.card__color-dot--selected')
      .forEach((el) => el.classList.remove('card__color-dot--selected'));
    dot.classList.add('card__color-dot--selected');

    if (dot.dataset.variantUrl) {
      card.querySelectorAll('.card__media-link, [id^="CardLink-"], [id^="StandardCardNoMediaLink-"]').forEach((link) => {
        link.href = dot.dataset.variantUrl;
      });
    }
  });
}
